<template>
	<div>
		<Header/>
		<router-view/>
  </div>
</template>
<script>
import Header from "@/components/Header"
export default {
	name: "app",
	components: {Header},
	data() {
		return this.$parent.$data
	}
}
</script>

<style lang="stylus">
@import "/style/raleway"
html, body 
	margin: 0
	min-height: 100%
* 
	font-family: "Raleway", "Arial", "Helvetica", sans-serif
	font-weight: 500
</style>
